export default __webpack_public_path__ + "static/media/users_white.72fe1e8c.svg";